import * as Sentry from '@sentry/nextjs';
import { FetchError } from '../FetchError/FetchError';

export const logToSentryOnFetchError = (
    err: FetchError | unknown,
    extra?: Record<string, unknown>,
) => {
    if (err instanceof FetchError) {
        const isErrorCodeStartingWith4 = (resError: FetchError) => {
            return String(resError?.status).startsWith('4');
        };

        if (isErrorCodeStartingWith4(err)) {
            return; // ignore 4xx errors
        } else {
            Sentry.captureException(err, {
                extra: {
                    details: err.info,
                    status: err.status,
                    ...extra,
                    message: extra?.message
                        ? `${extra.message as string} (${err.message})`
                        : err.message,
                },
            });
        }
    } else {
        return; //do not log non-fetch errors they should have been logged elsewhere
    }
};
